import React, { useCallback } from 'react'
import { Col, Row } from 'reactstrap'
import { Main, MainBody, MainTop, WhiteBox } from '@/components/Layout'
import { ValidationBoundary } from '@/components/validation'
import ErrorBoundary from '@/components/ErrorBoundary'
import context from '@/context'
import { useLocalization } from '@/hooks/localization'
import { ScopeDetailHeader } from '@/components/changeRequests/scopeDetailHeader'
import { FormLoader, FormRow, PropertyRenderer } from '@/components/changeRequests'

export const RtgsReportDetail = React.memo(function RtgsReportDetail (props) {
  const renderForm = useCallback(formProps => (<RtgsReportDetailForm {...formProps} />), [])

  const id = props.match.params.id
  const loaderFn =
    useCallback(id && id !== '0' ? id => context.api.rtgsService.get(id) : getNewRtgsReportItem, [])
  return (
    <FormLoader {...props} loader={loaderFn} render={renderForm} />
  )
})

function getNewRtgsReportItem () {
  return new Promise((resolve, reject) => {
    resolve({})
  })
}

export const RtgsReportDetailForm = React.memo(props => {
  const { localizeProps } = useLocalization()

  return (
    <Main>
      <MainTop>
        <ScopeDetailHeader title='Reporting.RtgsReport' backUrl='/Rtgsreports' >
          <PropertyRenderer name={localizeProps()} readonly />
        </ScopeDetailHeader>
      </MainTop>
      <MainBody transparent>
        <ValidationBoundary>
          <WhiteBox>
            <ErrorBoundary>
              <Row>
                <Col lg='6'>
                  <FormRow label='Institutions.CompanyDetailTitle' name='company' inputType='lookup'
                    dataSource={context.api.companyService.query} required />
                </Col>
                <Col lg='6'>
                  <FormRow label='Reporting.RtgsReferenceNumber' name='referenceNumber' clientSide required />
                </Col>
              </Row>
              <Row>
                <Col lg='6'>
                  <FormRow label='Reporting.RtgsDate' name='rtgsDate' inputType='date' clientSide required />
                </Col>
                <Col lg='6'>
                  <FormRow label='Common.FinancialYear' name='financialYear' inputType='number' inputProps={{ showPlain: true }} clientSide required />
                </Col>
              </Row>
              <Row>
                <Col lg='3'>
                  <FormRow label='Reporting.Q1SubmittedOn' name='q1SubmissionDate' inputType='date' clientSide />
                </Col>
                <Col lg='3'>
                  <FormRow label='Reporting.Q2SubmittedOn' name='q2SubmissionDate' inputType='date' clientSide />
                </Col>
                <Col lg='3'>
                  <FormRow label='Reporting.Q3SubmittedOn' name='q3SubmissionDate' inputType='date' clientSide />
                </Col>
                <Col lg='3'>
                  <FormRow label='Reporting.Q4SubmittedOn' name='q4SubmissionDate' inputType='date' clientSide />
                </Col>
              </Row>
              <Row>
                <Col lg='6'>
                  <FormRow label='Reporting.EndOfYearFinancialStatement' name='endOfYearFinancialStatement' inputType='date' clientSide />
                </Col>
                <Col lg='6'>
                  <FormRow label='Reporting.RtgsSavingLocation' name='savingLocation' inputType='textarea' clientSide />
                </Col>
              </Row>
            </ErrorBoundary>
          </WhiteBox>
        </ValidationBoundary>
      </MainBody>
    </Main>
  )
})



// WEBPACK FOOTER //
// ./src/internal-app/pages/rtgsReports/RtgsReportDetail.js